import { getRequest } from "../../../system/server-call";
import responseHandler from "../../../system/server-response-handler";
import { API_URLS, emptyString } from "../constants";

const { BRAND, STORE } = API_URLS;

//Stores data with filter
const getAllStores = ({
  search = emptyString,
  filter = "brand",
  from = 0,
  take = 15,
}) =>
  getRequest(
    `${BRAND.BASE}?search=${encodeURIComponent(search)}&filter=${filter}&from=${from}&take=${take}`
  )
    .then((response) => responseHandler.handleServerResponse(response))
    .catch((error) => responseHandler.handleHTTPResponses(error.response));

const getAllStoresByBrandId = (BrandId) =>
  getRequest(`${BRAND.GET_ALL_STORES_BY_BRAND_ID}/${BrandId}`)
    .then((response) => responseHandler.handleServerResponse(response))
    .catch((error) => responseHandler.handleHTTPResponses(error.response));

//Getting all the active brands
const getAllBrands = (isActiveOnly) =>
  getRequest(`${BRAND.GET_ALL_BRANDS}/${isActiveOnly}`)
    .then((response) => responseHandler.handleServerResponse(response))
    .catch((error) => responseHandler.handleHTTPResponses(error.response));

//Getting all brand locations against brand Id
const getStoresAgainstBrandId = (brandId) =>
  getRequest(`${STORE.GET_STORES}/${brandId}`)
    .then((response) => responseHandler.handleServerResponse(response))
    .catch((error) => responseHandler.handleHTTPResponses(error.response));

//Getting store by id
const getStoreById = (brandId) =>
  getRequest(`${BRAND.BASE}/${brandId}`)
    .then((response) => responseHandler.handleServerResponse(response))
    .catch((error) => responseHandler.handleHTTPResponses(error.response));

//Getting all stores against group Id
const getStoresAgainstGroupId = (groupId) =>
  getRequest(`${STORE.GET_STORES_BY_GROUP_ID}/${groupId}`)
    .then((response) => responseHandler.handleServerResponse(response))
    .catch((error) => responseHandler.handleHTTPResponses(error.response));

//Exporting functions for other files
export const storeService = {
  getAllStores,
  getAllBrands,
  getStoreById,
  getStoresAgainstBrandId,
  getStoresAgainstGroupId,
  getAllStoresByBrandId,
};
